import { render, staticRenderFns } from "./index.vue?vue&type=template&id=91515996&scoped=true&lang=html&"
import script from "./paction.js?vue&type=script&lang=js&"
export * from "./paction.js?vue&type=script&lang=js&"
import style0 from "./paction.styl?vue&type=style&index=0&id=91515996&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91515996",
  null
  
)

export default component.exports